import React from "react";

import ProgramStrategyPage from "./program-strategy-page";

const A2EProgramsPage: React.FC = () => (
  <ProgramStrategyPage
    programStrategyType="a2e"
    formId="a2e-programs-form"
    headerTitle="A2E program strategy"
    breadcrumbLabel="A2E"
  />
);

export default A2EProgramsPage;
